; (function (window, document, $, application) {
    'use strict';

    var ESC_KEY_KODE = 27;
    var $document = $(document);
    var $window = $(window);

    var OPTIONS = {
        componentSelector: '[data-ui-component="site-nav"]',
        buttonSelector: '[data-ui-component="site-nav-button"]',
        eventNamespace: '.navigation',
        eventName: 'click',
        stateClassName: 'has-nav-opened',
        otherClassNames: ['has-quick-search-opened'],
        buttonStateClassName: 'is-selected',
        itemSelector: '[data-ui-component="site-nav-item"]',
        linkItemSelector: '[data-ui-component="site-nav-link"]',
        toggleAction: '[data-action="toggle"]',
        hasChildrenClass: 'has-children',
        selectedClass: 'is-selected is-opened',
        expandedClass: 'is-expanded',
        searchButton: '[data-ui-component="quick-search-button"]'
    }

    var navigation = {
        init: function () {
            this.$html = $('html');
            this.$buttons = $(OPTIONS.buttonSelector);
            this.$component = $(OPTIONS.componentSelector);
            this.$toggleableLinkItems = this.$component.find(OPTIONS.linkItemSelector).filter(OPTIONS.toggleAction);
            this.$items = this.$component.find(OPTIONS.itemSelector);

            this.initEvents();
        },
        initEvents: function () {
            var event = (OPTIONS.eventName + OPTIONS.eventNamespace);
            $document.on('keyup', this.handleKeyUp.bind(this));
            $document.on(event, this.handleClick.bind(this));
            this.$buttons.on(event, this.toggle.bind(this));
            $window.on('resize' + OPTIONS.eventNamespace, this.close.bind(this));

            this.$toggleableLinkItems.on('click', this.handleItemClick.bind(this));
        },
        destroyEvents: function () {
            $document.off(OPTIONS.eventNamespace);
            this.$buttons.off(OPTIONS.eventNamespace);
            this.$component.off(OPTIONS.eventNamespace);
            $window.off(OPTIONS.eventNamespace);
        },
        toggle: function () {
            this.$html.toggleClass(OPTIONS.stateClassName);
            if (this.$html.hasClass(OPTIONS.stateClassName)) {
                OPTIONS.otherClassNames.forEach((className) => {
                    this.$html.removeClass(className);
                });
            }
            this.$buttons.toggleClass(OPTIONS.buttonStateClassName);
        },
        close: function () {
            if (this.isOpen()) {
                this.$component.trigger('closing');
                this.$buttons.removeClass(OPTIONS.buttonStateClassName);
            }
            
            this.$html.removeClass(OPTIONS.stateClassName);
            this.$toggleableLinkItems.closest('li').removeClass(OPTIONS.selectedClass + " " + OPTIONS.expandedClass);
        },
        isOpen: function () {
            return this.$html.hasClass(OPTIONS.stateClassName) || this.$items.hasClass(OPTIONS.selectedClass) || this.$items.hasClass(OPTIONS.expandedClass);
        },
        handleItemClick: function (e) {
            e.preventDefault();

            var $target = $(e.target).closest(OPTIONS.itemSelector);
            
            this.toggleItem($target);
        },
        toggleItem: function ($item) {
            if (this.isItemSelected($item)) {
                $item.removeClass(OPTIONS.selectedClass);
                $item.removeClass(OPTIONS.expandedClass);
                return;
            }
            else {
                this.$items.removeClass(OPTIONS.selectedClass);
                this.$items.removeClass(OPTIONS.expandedClass);
            }
            $item.toggleClass(OPTIONS.selectedClass);
        },
        isItemSelected: function($item) {
            return $item.hasClass(OPTIONS.selectedClass) | $item.hasClass(OPTIONS.expandedClass);
        },
        handleKeyUp: function (e) {
            if (e.which === ESC_KEY_KODE) {
                this.close();
            }
        },
        handleClick: function (e) {
            var $target = $(e.target);
            var targetOutside = ($target.closest(OPTIONS.itemSelector + ',' + OPTIONS.buttonSelector).length === 0);
            
            if (targetOutside) {
                this.close();
            }
        }
    };

    navigation.init();
})(window, document, jQuery);